import { Button } from '@/components/ui/button'
import { ArrowDownCircle } from 'lucide-react'

export const Hero = () => {
  const scrollToCep = () => {
    const element = document.querySelector('#cep-checker')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  return (
    <section
      id="hero"
      className="relative w-full h-[90vh] min-h-[600px] flex items-center bg-gray-900 overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://lh3.googleusercontent.com/d/1E-eJSmYMDgBaZQtKPZ_lBup8y4-YwVs3"
          alt="Frota Transbio"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/30" />
      </div>

      <div className="container mx-auto px-4 z-10 relative">
        <div className="max-w-3xl animate-fade-in-up">
          <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-primary/20 border border-primary/30 backdrop-blur-sm">
            <span className="text-white text-sm font-semibold tracking-wide uppercase shadow-sm">
              Excelência em Gestão de Resíduos
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight mb-6 drop-shadow-lg">
            Transportando <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-green-600">
              Responsabilidade Ambiental
            </span>
          </h1>

          <p className="font-body text-lg md:text-xl text-gray-200 mb-8 max-w-2xl leading-relaxed drop-shadow-md">
            Soluções completas para o Gerenciamento dos Resíduos dos Serviços de
            Saúde. Da coleta até a destinação final Ambientalmente Adequada.
            Verifique se atendemos a sua região.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              onClick={scrollToCep}
              className="bg-primary hover:bg-primary/90 text-white font-semibold px-8 py-6 text-lg rounded-full shadow-lg shadow-primary/30 hover:scale-105 transition-transform"
            >
              Verificar Atendimento na Minha Região
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() =>
                document
                  .querySelector('#services')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
              className="bg-transparent border-white text-white hover:bg-white/10 font-semibold px-8 py-6 text-lg rounded-full shadow-sm"
            >
              Conhecer Serviços
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ArrowDownCircle className="text-white/70 h-10 w-10 drop-shadow-md" />
      </div>
    </section>
  )
}
